/** 
 * 图片资源文件
 */

import { isWidthUp } from "@material-ui/core";

/** puclic文件夹路径 */
const PUBLIC_URL = process.env.PUBLIC_URL;

export const Login = {
  logo: `${PUBLIC_URL}/images/login/logo.png`,
};

/**
 * 格式化图片路径
 *
 * @param {*} width 宽度
 * @param {*} comPath 通用路径
 * @param {*} imgMap 图片路径映射
 * @return {*} 
 */
function formatDevTypeData({ width, comPath, imgMap }) {
  const DevType = isWidthUp("md", width) ? "pc" : "mobile"
  const ImgPath = `${PUBLIC_URL}${comPath}/${DevType}`
  const keyArr = Object.keys(imgMap)
  const newObj = {}
  keyArr.forEach(key => {
    newObj[key] = `${ImgPath}${imgMap[key]}`
  });
  return newObj
}

/** 版本对比图片 */
export const VersionCompareImg = {
  imgByWidth: (width) => {
    return formatDevTypeData({
      width,
      comPath: "/images/versionCompare",
      imgMap: {
        bannerOutComSer: "/banner_out_com_ser.png",
        bannerInterLogis: "/banner_inter_logis.png",
        bannerBigData: "/banner_big_data.png",
      }
    })
  }
};

// /** 背景图片 */
export const BgImg = {
  recommend: `${PUBLIC_URL}/images/bgImg/recommend.png`,
  logo: `${PUBLIC_URL}/images/bgImg/logo.png`,
};

/** 联系我们 */
export const ImgContact = {
  address: `${PUBLIC_URL}/images/contact/address.png`,
  email: `${PUBLIC_URL}/images/contact/email.png`,
  landline: `${PUBLIC_URL}/images/contact/landline.png`,
  website: `${PUBLIC_URL}/images/contact/website.png`,
};

/** 客户案例 */
export const ImgCustomerCase = {
  imgByWidth: (width) => {
    return formatDevTypeData({
      width,
      comPath: "/images/customerCase",
      imgMap: {
        banner: "/banner.png",
        zyck: "/zyck.png",
        lzdl: "/lzdl.png",
        lzzy: "/lzzy.png",
      }
    })
  }
};

/** 关于我们 */
export const ImgAboutUs = {
  company: `${PUBLIC_URL}/images/aboutUs/company.png`,
  banner: `${PUBLIC_URL}/images/aboutUs/banner.png`,
  // certificate_1: `${PUBLIC_URL}/images/aboutUs/certificate_1.png`,
  // certificate_2: `${PUBLIC_URL}/images/aboutUs/certificate_2.png`,
  // certificate_3: `${PUBLIC_URL}/images/aboutUs/certificate_3.png`,
  // certificate_4: `${PUBLIC_URL}/images/aboutUs/certificate_4.png`,
  // certificate_5: `${PUBLIC_URL}/images/aboutUs/certificate_5.png`,
  // certificate_6: `${PUBLIC_URL}/images/aboutUs/certificate_6.png`,
  // certificate_7: `${PUBLIC_URL}/images/aboutUs/certificate_7.png`,

  sw_1:`${PUBLIC_URL}/images/aboutUs/sw/1.png`,
  sw_2:`${PUBLIC_URL}/images/aboutUs/sw/2.png`,
  sw_3:`${PUBLIC_URL}/images/aboutUs/sw/3.png`,
  sw_4:`${PUBLIC_URL}/images/aboutUs/sw/4.png`,
  sw_5:`${PUBLIC_URL}/images/aboutUs/sw/5.png`,
  sw_6:`${PUBLIC_URL}/images/aboutUs/sw/6.png`,
  sw_7:`${PUBLIC_URL}/images/aboutUs/sw/7.png`,
  sw_8:`${PUBLIC_URL}/images/aboutUs/sw/8.png`,
  sw_9:`${PUBLIC_URL}/images/aboutUs/sw/9.png`,
  sw_10:`${PUBLIC_URL}/images/aboutUs/sw/10.png`,
  sw_11:`${PUBLIC_URL}/images/aboutUs/sw/11.png`,
  sw_12:`${PUBLIC_URL}/images/aboutUs/sw/12.png`,
  sw_13:`${PUBLIC_URL}/images/aboutUs/sw/13.png`,
  sw_14:`${PUBLIC_URL}/images/aboutUs/sw/14.png`,
  sw_15:`${PUBLIC_URL}/images/aboutUs/sw/15.png`,
  sw_16:`${PUBLIC_URL}/images/aboutUs/sw/16.png`,
  sw_17:`${PUBLIC_URL}/images/aboutUs/sw/17.png`,

  qa_1:`${PUBLIC_URL}/images/aboutUs/qa/1.png`,
  qa_2:`${PUBLIC_URL}/images/aboutUs/qa/2.png`,
  qa_3:`${PUBLIC_URL}/images/aboutUs/qa/3.png`,
  qa_4:`${PUBLIC_URL}/images/aboutUs/qa/4.png`,
  qa_5:`${PUBLIC_URL}/images/aboutUs/qa/5.png`,
  qa_6:`${PUBLIC_URL}/images/aboutUs/qa/6.png`,

  other_1:`${PUBLIC_URL}/images/aboutUs/other/1.png`,
};

/** 导航 */
export const ImgNav = {
  logo: `${PUBLIC_URL}/images/home/navLogo.png`,
};

/** 首页 */
export const ImgHome = {
  banner1: `${PUBLIC_URL}/images/home/banner1.png`,
  banner2: `${PUBLIC_URL}/images/home/banner2.png`,
  base: `${PUBLIC_URL}/images/home/base.png`,
  car: `${PUBLIC_URL}/images/home/car.png`,
  people: `${PUBLIC_URL}/images/home/people.png`,
  customer: `${PUBLIC_URL}/images/home/customer.png`,
  world: `${PUBLIC_URL}/images/home/world.png`,
  computer: `${PUBLIC_URL}/images/home/computer.png`,
  handshake: `${PUBLIC_URL}/images/home/handshake.png`,
  buildings: `${PUBLIC_URL}/images/home/buildings.png`,
  acme: `${PUBLIC_URL}/images/home/acme.png`,
  goods: `${PUBLIC_URL}/images/home/goods.png`,
  goods1: `${PUBLIC_URL}/images/home/goods1.png`,
  mask: `${PUBLIC_URL}/images/home/mask.png`,
  cases: `${PUBLIC_URL}/images/home/cases.png`,
};

/** 消息中心 */
export const ImgNotifies = {
  message: `${PUBLIC_URL}/images/notifies/message.png`,
};

/** 产品-大数据 */
export const ImgProductService = {
  imgByWidth: (width) => {
    return formatDevTypeData({
      width,
      comPath: "/images/product/service",
      imgMap: {
        banner: "/banner.png",
        charact:"/charact.png",
      }
    })
  }
};
/** 产品-大数据 */
export const ImgProductLogistics = {
  imgByWidth: (width) => {
    return formatDevTypeData({
      width,
      comPath: "/images/product/logistics",
      imgMap: {
        banner: "/banner.png",
        charact:"/charact.png",
      }
    })
  }
};
/** 产品-大数据 */
export const ImgProductBigData = {
  cardLogo: `${PUBLIC_URL}/images/product/bigData/cardLogo.png`,
  bgCircle: `${PUBLIC_URL}/images/product/bigData/bgCircle.png`,
  dashboard: `${PUBLIC_URL}/images/product/bigData/dashboard.png`,
  pointer: `${PUBLIC_URL}/images/product/bigData/pointer.png`,
  imgByWidth: (width) => {
    return formatDevTypeData({
      width,
      comPath: "/images/product/bigData",
      imgMap: {
        banner: "/banner.png",
      }
    })
  }
};

export const Invoice = {
  rmb: `${PUBLIC_URL}/images/invoice/rmb.png`,
};

/** 缺省页（移动端） */
export const ImgDefaultMD = {
  msg: `${PUBLIC_URL}/images/defaultMD/msg.png`,
  net: `${PUBLIC_URL}/images/defaultMD/net.png`,
  list: `${PUBLIC_URL}/images/defaultMD/list.png`,
};